import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { getIsLoggedIn } from '@wix/da-shared-react/pkg/publicSession/selectors';
import { hasSubscriptions } from '../../../../../selectors/pageLayout';
import { AppState } from '../../../../../../types/store';
import {
  getProfileOwnerIsWatcher,
  getProfileOwnerUser,
  isCurrentUserProfileOwner,
  getProfileOwnerIsContactable,
} from '../../../../../selectors/users';
import { getCanCustomizePage } from '../../../../../selectors/privs';
import { blockProfileOwner } from '../../../../../actions/profileOwner';
import { Props } from './UserProfileSubNavDesktopInner';

type StateProps = Pick<
  Props,
  | 'isOwner'
  | 'profileOwnerUser'
  | 'isAuthorizedToCustomize'
  | 'isProfileOwnerWatchingCurrentUser'
  | 'isLoggedIn'
  | 'hasSubscriptions'
  | 'isContactable'
>;
type DispatchProps = Pick<Props, 'blockProfileOwner'>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  isOwner: isCurrentUserProfileOwner(state),
  profileOwnerUser: getProfileOwnerUser(state),
  isAuthorizedToCustomize: getCanCustomizePage(state),
  isProfileOwnerWatchingCurrentUser: getProfileOwnerIsWatcher(state),
  isLoggedIn: getIsLoggedIn(state),
  hasSubscriptions: hasSubscriptions(state),
  isContactable: getProfileOwnerIsContactable(state),
});

const mapDispatchToProps: MapDispatchToProps<
  DispatchProps,
  OwnProps
> = dispatch => ({
  blockProfileOwner: () => dispatch(blockProfileOwner()),
});

export default connect(mapStateToProps, mapDispatchToProps);
